import { Routes as NamedRoutes } from '@/routes'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'

import { Authenticate } from './Auth/Authenticate'
import { ProtectedRoutes } from './Auth/ProtectedRoutes'
import { Dashboard } from './Dashboard/Dashboard'
import { Success } from './Success/Success'
import { WorkspaceContainer } from './Workspace'
import { CreateWorkspaceDialog } from './WorkspaceEditor'

import type { FC } from 'react'

export const App: FC = () => {
	return (
		<div className="h-full">
			<Routes>
				<Route path={NamedRoutes.Authenticate} element={<Authenticate />} />
				<Route element={<ProtectedRoutes />}>
					<Route path={NamedRoutes.Dashboard} element={<Dashboard />} />
					<Route path=":workspaceId/*" element={<WorkspaceContainer />} />
				</Route>
				<Route path={NamedRoutes.Success} element={<Success />} />
				<Route
					key={NamedRoutes.WildCard}
					path={NamedRoutes.WildCard}
					element={<Navigate to={NamedRoutes.Authenticate} />}
				/>
			</Routes>
			<CreateWorkspaceDialog />
			<Toaster />
		</div>
	)
}
